export default __webpack_public_path__ + "static/media/img27.c555f861.jpg";